import "./Navbar.css";
import { useSelector } from "react-redux";
import AverageWPM from "../gaming_components/AverageWPM/AverageWPM";
import MultiplayerWPM from "../gaming_components/MultiplayerWPM/MultiplayerWPM";
export default function NavBar({connected_count}){
    const { socket_connected } = useSelector(state => state.game);
    return(
        <section
        className = "typing-racer-nav"
        >
            <header 
            className = "typing-racer-nav__title"
            >
                <h1 className="typing-racer-nav__color">
                    RACETYP3 v2
                </h1>
                <div className="typing-racer-nav-socket">                            
                <div className={socket_connected ? "socket-color socket-color--connected" : "socket-color"}></div>
                    <p>{socket_connected ? `${connected_count} Online`:"not connected"}</p>
                </div>
            </header>
            <div>
            <AverageWPM/> 
            <MultiplayerWPM/>            
            </div>
        </section>
    );
}